const AFF_ID_STORAGE_KEY = "aff_id";
const AFF_ID_PARAM = "aff_id";
const REF_PARAM = "ref";

/**
 * Persists the landing URL's affiliate id into `localStorage` under the
 * `aff_id` key read by auth and the attribution bridge. Must run at the start
 * of `initializeApp` (before auth snapshots `aff_id`): a same-page profile
 * create on a first visit would otherwise POST without `affiliate_id`.
 */
export function persistAffiliateFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  const affiliateId = params.get(AFF_ID_PARAM) || params.get(REF_PARAM);
  if (affiliateId) {
    localStorage.setItem(AFF_ID_STORAGE_KEY, affiliateId);
  }
}

export default persistAffiliateFromUrl;
